import { Loader2 } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { useBillingSession } from "@/lib/billing-session";

/**
 * The billing impact of an invitation or member change, shown before it is confirmed. While a
 * cancellation is scheduled, paid seats are blocked and the notice offers to resume the
 * subscription (the Customer Portal, via the shared billing session).
 */
export function SeatBillingNotice(props: { message: string; blocked: boolean }) {
  if (props.blocked) {
    return (
      <Alert variant="warning">
        <AlertTitle>Subscription ending</AlertTitle>
        <AlertDescription>
          <p>{props.message}</p>
          <ResumeSubscriptionButton />
        </AlertDescription>
      </Alert>
    );
  }
  return (
    <div className="rounded-lg border px-3 py-3">
      <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Billing</p>
      <p className="mt-1 text-sm">{props.message}</p>
    </div>
  );
}

function ResumeSubscriptionButton() {
  const billingSession = useBillingSession({ returnPath: "/organization" });
  return (
    <Button
      type="button"
      size="sm"
      className="mt-2"
      disabled={billingSession.pendingAction !== null}
      onClick={() => void billingSession.open("manage")}
    >
      {billingSession.pendingAction ? <Loader2 className="size-4 animate-spin" /> : null}
      Resume subscription
    </Button>
  );
}
